import { render, staticRenderFns } from "./Add.vue?vue&type=template&id=655a8420&scoped=true&"
import script from "./Add.vue?vue&type=script&lang=js&"
export * from "./Add.vue?vue&type=script&lang=js&"
import style0 from "./Add.vue?vue&type=style&index=0&id=655a8420&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../steam-app-cms-prod/steam-app-cms/sources/client/fastboot-cms-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655a8420",
  null
  
)

export default component.exports